import React from 'react';
import { useTranslation } from 'react-i18next';
import { TPhoneVerification } from './PhoneVerification.types';

const PhoneVerification: React.FC<TPhoneVerification> = (props: TPhoneVerification): React.ReactElement => {
	const {
		isSMSSent,
		handleSendSMS,
		handleCodeInput,
		handlePhoneVerification,
		message,
		phoneNumber,
		handleChangePhoneNumber,
		isPhoneUpdated,
		handleUpdatePhoneNumber
	} = props;
	const { t } = useTranslation();
	return <div className={'phone-verification-form'}>
		<p className={'text-center'}>{t('pages.personal.phoneVerification.please')}</p>
		<p className={'text-center'}>{t('pages.personal.phoneVerification.weWillSend')}</p>
		<p className={'text-center'}>{t('pages.personal.phoneVerification.yourPhone')}</p>
		<input type="text" value={phoneNumber || ''} onInput={handleChangePhoneNumber}/>
		{!isSMSSent && (
			isPhoneUpdated ?
				<button className={'active'} onClick={handleSendSMS}>{t('pages.personal.phoneVerification.sendSMS')}</button>
				: <button className={'active'}
									onClick={handleUpdatePhoneNumber}>{t('pages.personal.phoneVerification.update')}</button>
		)}
		{isSMSSent ? <>
			<p className="text-center">{t('pages.personal.phoneVerification.enterCode')}</p>
			<input type="text" onInput={handleCodeInput}/>
			<button className={'active'}
							onClick={handlePhoneVerification}>{t('pages.personal.phoneVerification.verify')}</button>
			<p className="text-center error">{message}</p>
		</> : null}
	</div>;
};

export default PhoneVerification;
